import $http from './http'
import config from './config'

export default {
    name: 'statistics',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getStatisticsList(data) {
        return $http.post(this.getUrl(`/TradeStatistics/List`), data);
    },
    getTradesDetail(data){
        return $http.post(this.getUrl('/TradeDetail/List'),data)
    },
    TradeStatisticsList(data) {
        /**
         * @method 查询统计数据
         **/

        //  data = {
        //     ClientID:'',//公司编号
        //     CenterID: '',//成本中心编号
        //     DepartmentID: '',//部门编号
        //     ProjectCode: '',//项目代码
        //     BookingTime: '',//预订开始日期
        //     BookingTimeEnd:'',//预订截至日期
        // }
        return $http.post(this.getUrl(`/TradeStatistics/TradeStatisticsList`), data);
    },
    getTotalCompanyByUser(data) {
        return $http.post(this.getUrl(`/TradeStatistics/GetTotalCompanyByUser`), data);
    },
    searchtrades(data){
        return $http.post(this.getUrl("/TradeDetail/SearchTradeList"),data)
    },
    savetrades(data){
        return $http.post(this.getUrl("/UserStatistics/Save"),data)
    }
}



// WEBPACK FOOTER //
// ./src/apis/statisticsApis.js